import React from "react";
import FileTraceAlertSection from "./FileTraceAlertSection/FileTraceAlertSection";
import FileTraceFilterSection from "./FileTraceFilterSection/FileTraceFilterSection";
import FileTraceTableSection from "./FileTraceTableSection/FileTraceTableSection";
import QMSErrorHandle from "./../../auxil/QMSErrorHandle";
import {
  Modal,
  Steps,
  Input,
  Tooltip,
  Tabs,
  Row,
  Col,
  Spin,
  Button,
  Empty,
  Select,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { editOptions } from "./FileTraceTableSection/FileTraceTableUtils";
import saveAs from "file-saver/src/FileSaver";
import cloneDeep from "lodash/cloneDeep";
import _ from "lodash";
import moment from "moment";
import "moment-timezone";

import CommonConfig from "../../commonConfig.json";
import { axiosInstanceQMS } from "../../../utils/axiosConfig";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import setSidebarSolution from "../../../store/actions/sidebarActions";
import {
  setToggleSidebar,
  setSidebarSelected,
} from "../../../store/actions/navbarActions";

import "antd/dist/antd.css";
import "./FileTrace.css";

const { Step } = Steps;
const { TabPane } = Tabs;
const { Option } = Select;

const timelineSteps = require("./timelineSteps.json");

let commonValuesTypes = CommonConfig.commonValuesTypes;

const ENVS = CommonConfig.envs;
let REACT_APP_HMG = process.env["REACT_APP_HMG"];

class FileTraceGM extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.sourceFileDW = React.createRef();
    let sessionStorageData = JSON.parse(sessionStorage.getItem("sessionData"));

    if (sessionStorageData == null) {
      sessionStorageData = { date: null, time: null };
    }

    this.state = {
      originalData: {},
      data: {},
      isEditable: false,
      isEditableLbl: editOptions.edit,
      editedRows: {},
      editedDropdown: [],
      tabId: [],
      sessionData: sessionStorageData,
      searchData: {},
      reportData: [],
      mappedReports: [],
      hideAlert: true,
      contentLoadingStatus: false,
      modalVisible: false,
      modalProps: {},
      tablist: [],
      searchIndexes: [],
      allowedConnectors: [],
      tableIndexes: [],
      indexSortOrder: [],
      uniqueIndexes: [],
      reduxLoadingCount: 0,
      isOpen: true,
      hotelSelected: false,
      hotelReportList: [],
      validSubmissionSchedules: [],
      validReportCategories: [],
      hmgList: [],
      currentHMG: "",
      entityId: null,
      changeHMGEvent: false,
    };

    //bind state to methods
    this.updateSessionData = this.updateSessionData.bind(this);
    this.updateDropdownData = this.updateDropdownData.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.saveData = this.saveData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.updateSearchData = this.updateSearchData.bind(this);
    this.searchReportData = this.searchReportData.bind(this);
    // this.updateReportsDrpodown = this.updateReportsDrpodown.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.stepChange = this.stepChange.bind(this);
    this.changePage = this.changePage.bind(this);
    this.downloadSourceFile = this.downloadSourceFile.bind(this);
    this.printError = this.printError.bind(this);
    this.selectTab = this.selectTab.bind(this);
    this.changeHMG = this.changeHMG.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.setHMG = this.setHMG.bind(this);
    this.resetHotel = this.resetHotel.bind(this);
    this.setSidebarClick = this.setSidebarClick.bind(this);
  }

  sidebarClick = false;

  setSidebarClick(newSidebarClick) {
    this.sidebarClick = newSidebarClick;
  }

  errorObject = {
    err: false,
    errCode: null,
    errType: null,
    errMsg: null,
    display: false,
  };

  setHMG(entityId) {
    this.setState({ entityId: entityId });
  }

  printError(newError) {
    this.errorObject = newError;
    //this.forceUpdate();
    this.setState({ contentLoadingStatus: false });
    setTimeout(() => {
      this.errorObject = {
        err: false,
        errCode: null,
        errType: null,
        errMsg: null,
        display: false,
      };
    }, 1000);
  }

  openModal(cellData) {
    let stepList = [];

    let stepDefn = timelineSteps[cellData.column];
    if (stepDefn === undefined || stepDefn === null) {
      this.printError({
        display: true,
        err: true,
        errCode: "500",
        errType: "",
        errMsg: "Timeline does not exist",
      });
      return;
    }
    let stepNames = [];
    for (let x = 0; x < stepDefn.steps.length; x++) {
      let disableStep = false;
      let status = "finish";
      let icon = "";
      if (x < cellData.current) {
        icon = <CheckCircleOutlined style={{ color: "green" }} />;
      } else if (x === cellData.current) {
        status = cellData.status;

        if (status === "fail") {
          icon = <CloseCircleOutlined style={{ color: "red" }} />;
        } else if (status === "finish") {
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
        }
      } else if (x > cellData.current) {
        disableStep = true;
        status = "wait";
      }
      if (icon === "") {
        stepList.push(
          <Step
            title={stepDefn.steps[x]}
            status={status}
            disabled={disableStep}
          />
        );
      } else {
        stepList.push(
          <Step
            title={stepDefn.steps[x]}
            icon={icon}
            status={status}
            disabled={disableStep}
          />
        );
      }
      stepNames.push(stepDefn.steps[x]);
    }

    let modalProps = {};
    modalProps["content"] = stepList;
    modalProps["current"] = cellData.current;
    modalProps["title"] = "Process Timeline";
    modalProps["width"] = stepDefn.width;
    modalProps["additionalData"] = cellData.additionalData;
    modalProps["additionalDataStr"] =
      cellData.additionalData[cellData.current] === undefined ||
      cellData.additionalData[cellData.current] === null
        ? ""
        : this.processModalAdditionalData(
            cellData.additionalData[cellData.current],
            ""
          );
    modalProps["stepNames"] = stepNames;
    modalProps["currentStepName"] = modalProps["stepNames"][cellData.current];
    modalProps["additionalDataTS"] =
      cellData.additionalData[cellData.current] === undefined ||
      cellData.additionalData[cellData.current] === null
        ? ""
        : this.processModalAdditionalDataTS(
            cellData.additionalData[cellData.current]
          );
    this.setState({ modalVisible: true, modalProps: modalProps });
  }

  processModalAdditionalData(additionalData, counter) {
    let formatted = [];
    counter = counter === "" ? counter : counter + ".";
    for (let x = 0; x < additionalData.length; x++) {
      let subFormatted = [];
      //alert(JSON.stringify(additionalData[x].sub));
      if (
        additionalData[x].key === undefined ||
        additionalData[x].key !== "eventTime"
      ) {
        if (
          additionalData[x].display != undefined &&
          additionalData[x].display != true
        ) {
          continue;
        }
        if (
          additionalData[x].sub !== undefined &&
          additionalData[x].sub !== null
        ) {
          subFormatted = this.processModalAdditionalData(
            additionalData[x].sub,
            counter + (x + 1)
          );
        }
        let printVal = "";
        if (
          this.props.permitExtraDetails.FileDownloadPermit == true &&
          additionalData[x].link !== undefined &&
          additionalData[x].link === true
        ) {
          printVal = (
            <div style={{ display: "inline" }}>
              <span
                class="docDownloadLink"
                onClick={() => {
                  this.downloadSourceFile(additionalData[x].meta);
                }}
              >
                {additionalData[x].val}
              </span>
              {/* <a id={'SFD_'+additionalData[x].meta.docId} ref={this.sourceFileDW} download={'sourceFile_'+ additionalData[x].meta.docId} ></a> */}
            </div>
          );
        } else if(additionalData[x].key === "docFraction") {
          printVal = "Received Count/Expected Count : " +
            additionalData[x].val[0] + "/" +
            additionalData[x].val[1];
        } else {
          if(additionalData[x].title !== undefined) {
            printVal = additionalData[x].title + ": "+ additionalData[x].val;
          } else {
            printVal = additionalData[x].val;
          }
        }
        formatted.push(
          <div>
            {counter + (x + 1) + ". \t "}
            {printVal}
            <div>{subFormatted}</div>
          </div>
        );
      }
    }
    return <ol>{formatted}</ol>;
  }

  /** Download Source file */
  downloadSourceFile(linkData) {
    if (
      linkData.s3Bucket !== undefined &&
      linkData.s3Bucket != null &&
      linkData.s3Bucket != "" &&
      linkData.s3Key !== undefined &&
      linkData.s3Key != null &&
      linkData.s3Key != ""
    ) {
      let s3Bucket = linkData.s3Bucket;
      let s3key = linkData.s3Key;
      let docId = linkData.docId;
      axiosInstanceQMS
        .get("/api/callExternal/downloadSourceFile", {
          params: {
            bucket: s3Bucket,
            s3Key: s3key,
          },
          responseType: "blob",
        })
        .then((response) => {
          if (response["data"]["error"]) {
            console.error("ERROR :", response["data"]["errorMessage"]);
            let errorMessage =
              response["data"]["display"] != undefined &&
              response["data"]["display"]
                ? response["data"]["errorMessage"]
                : "Error occured";
            this.printError({
              display: true,
              err: true,
              errCode: "500",
              errType: "",
              errMsg: errorMessage,
            });
            return;
          } else {
            // console.log(response);
            // console.log('file',response);
            // console.log('headers',response);
            //console.log('content-type',response[]);
            console.log(typeof response["data"]);

            const blob = new Blob([response["data"]], {
              type: response["headers"]["content-type"],
            });
            saveAs(blob, s3key);
            // const url = URL.createObjectURL(blob);
            // var aNode = this.sourceFileDW.current;
            // aNode.href = url;
            // aNode.click();
            // URL.revokeObjectURL(url);
            return true;
          }
        })
        .catch((error) => {
          console.error("ERROR :", error);
          this.printError({
            display: true,
            err: true,
            errCode: "500",
            errType: "",
            errMsg: "Document Not Available",
          });
        });
    } else {
      console.error("ERROR : S3 data not set in link");
      this.printError({
        display: true,
        err: true,
        errCode: "500",
        errType: "",
        errMsg: "Document Data Not Available",
      });
    }
  }

  processModalAdditionalDataTS(additionalData) {
    let formatted = "";

    if (additionalData.length > 0) {
      let lastRecord = additionalData[additionalData.length - 1];
      if (lastRecord.key !== undefined && lastRecord.key === "eventTime") {
        let val = lastRecord["val"];
        let shortTimezone = this.getTimezone();
        let dte = moment.utc(val);
        let local = moment(dte).local();
        val = local.format("MM-DD-YYYY hh:mm:ss A");
        formatted = <div>{val + " " + shortTimezone}</div>;
      }
    }

    return formatted;
  }

  stepChange(current) {
    let modalProps = this.state.modalProps;
    let dataStr =
      modalProps.additionalData[current] === undefined ||
      modalProps.additionalData[current] === null
        ? ""
        : this.processModalAdditionalData(
            modalProps.additionalData[current],
            ""
          );
    let additionalDataTS =
      modalProps.additionalData[current] === undefined ||
      modalProps.additionalData[current] === null
        ? ""
        : this.processModalAdditionalDataTS(modalProps.additionalData[current]);
    modalProps["additionalDataStr"] = dataStr === undefined ? "" : dataStr;
    modalProps["current"] = current;
    modalProps["currentStepName"] = modalProps["stepNames"][current];
    modalProps["additionalDataTS"] = additionalDataTS;
    this.setState({ modalProps: modalProps });
  }

  getTimezone() {
    let timeZone = moment.tz.guess();
    let shortTimeZone = moment.tz(timeZone).zoneAbbr();

    if (shortTimeZone.charAt(0) === "+" || shortTimeZone.charAt(0) === "-") {
      shortTimeZone = "";
      let timeSplit = new Date().toString().split("(")[1].split(" ");
      timeSplit.forEach((zonePiece) => {
        shortTimeZone += zonePiece.charAt(0);
      });
    }

    return shortTimeZone;
  }

  handleOk() {
    this.setState({ modalVisible: false });
  }

  handleCancel() {
    this.setState({ modalVisible: false });
  }

  clearSearch() {
    this.setState({ searchData: {}, hotelSelected: false }, () => {
      this.searchReportData(true);
    });
  }

  resetHotel() {
    this.setState({ hotelSelected: false }, () => {
      this.updateSearchData(
        commonValuesTypes.HOTELS,
        null,
        "",
        commonValuesTypes.HOTELS,
        ""
      );
    });
  }

  resetBDate() {
    this.updateSearchData(
      commonValuesTypes.DATE,
      null,
      "",
      commonValuesTypes.DATE,
      ""
    );
  }
  // NEW
  updateSearchData(key, selectedOption, searchIn, valuesType, additionalData) {
    //update search data
    const newSearchData = this.state.searchData;

    if (selectedOption === null) {
      newSearchData[key] = null;

      if (valuesType == commonValuesTypes.HOTELS) {
        newSearchData[additionalData] = null;
        newSearchData[this.submissionScheduleIndex] = null;
        newSearchData[this.reportCategoryIndex] = null;
        newSearchData[this.reportsIndex] = null;

        this.setState({
          searchData: newSearchData,
          reportData: this.reportsIndexValues,
          hotelSelected: false,
          validSubmissionSchedules: [],
          validReportCategories: this.reportCategoryIndexValues,
        });
      } else if (valuesType === commonValuesTypes.SUBMISSION_SCHEDULE) {
        let hotelReportList = this.state.hotelReportList;

        let validReportCategories = [];
        let validReportNames = [];
        hotelReportList.forEach((report) => {
          validReportNames.push({
            value: report.reportName,
            label: report.reportName,
          });
          report.reportCategory.forEach((category) => {
            //filtering report category by schedule
            if (!validReportCategories.includes(category)) {
              validReportCategories.push(category);
            }
          });
        });

        this.setState({
          reportData: validReportNames,
          validReportCategories: validReportCategories,
        });

        // }else if(valuesType == "Reports"){

        //     let hotelReportList = this.state.hotelReportList;
        //     let validSubmissionSchedules = [];

        //     hotelReportList.forEach(report => {
        //         if(!validSubmissionSchedules.includes(report.scheduleType)){
        //             validSubmissionSchedules.push(report.scheduleType);
        //         }
        //     });

        //     this.setState({ validSubmissionSchedules: validSubmissionSchedules });
      } else {
        this.setState({ searchData: newSearchData });
      }
    } else {
      if (valuesType == commonValuesTypes.HOTELS) {
        this.setState({ contentLoadingStatus: true }, async () => {
          //clear reports
          newSearchData[additionalData] = null;
          // this.setState({ reportData: [], searchData: newSearchData });

          let newReportData = [];

          newSearchData[key] = {
            searchVal:
              REACT_APP_HMG === ENVS.GENERIC
                ? selectedOption["name"]
                : selectedOption["code"],
            searchIn: searchIn,
          };
          //load reports for hotel
          // const mappedReports = cloneDeep(this.state.mappedReports);

          //call new hotelReport API
          let hotelReportList = await new Promise((resolve, reject) => {
            axiosInstanceQMS
              .post("/api/userHotels/getUserHotelReportList2", {
                userName: this.props.user["https://myapp.com/UserName"],
                hotel: selectedOption["name"],
                projectDetails: this.projectDetails,
              })
              .then((response) => {
                if (response["data"]["error"]) {
                  console.error("ERROR :", response["data"]["errorMessage"]);

                  let errorMessage =
                    response["data"]["display"] != undefined &&
                    response["data"]["display"]
                      ? response["data"]["errorMessage"]
                      : "Error occured";
                  this.printError({
                    display: true,
                    err: true,
                    errCode: "500",
                    errType: "",
                    errMsg: errorMessage,
                  });
                  resolve(null);
                } else {
                  let reports = response["data"]["reports"];
                  resolve(reports);
                }
              })
              .catch((error) => {
                console.error("ERROR :", error);
                this.printError({
                  display: true,
                  err: true,
                  errCode: "400",
                  errType: "",
                  errMsg: "Error occured : " + error.message,
                });
                resolve(null);
              });
          });

          let validSubmissionSchedules = [];
          let validReportCategories = [];
          hotelReportList.forEach((report) => {
            if (!validSubmissionSchedules.includes(report.scheduleType)) {
              validSubmissionSchedules.push(report.scheduleType);
            }
            report.reportCategory.forEach((category) => {
              if (!validReportCategories.includes(category)) {
                validReportCategories.push(category);
              }
            });
          });
          newSearchData[this.submissionScheduleIndex] = null;
          newSearchData[this.reportCategoryIndex] = null;
          newSearchData[this.reportsIndex] = null;

          let hotelSelectedState = {
            contentLoadingStatus: false,
            hotelSelected: true,
            hotelReportList: hotelReportList,
            validSubmissionSchedules: validSubmissionSchedules,
            validReportCategories: validReportCategories,
          };

          if (hotelReportList === null) {
            this.setState(hotelSelectedState);
          } else {
            for (const hotelReport of hotelReportList) {
              newReportData.push({
                value: hotelReport.reportName,
                label: hotelReport.reportName,
              });
            }

            hotelSelectedState.searchData = newSearchData;
            hotelSelectedState.reportData = newReportData;
            this.setState(hotelSelectedState);
          }
        });
      } else if (key == "eventTime") {
        selectedOption = moment(selectedOption, "MM-DD-YYYY").format(
          "YYYY-MM-DD"
        );

        newSearchData[key] = {
          searchVal: selectedOption,
          searchIn: searchIn,
        };

        this.setState({ searchData: newSearchData });
      } else if (valuesType === commonValuesTypes.SUBMISSION_SCHEDULE) {
        let hotelReportList = this.state.hotelReportList;

        // let filteredReports = hotelReportList.filter( report => {
        //     return (report.scheduleType === selectedOption);
        // }).map( report => {
        //     return report.reportName;
        // });

        newSearchData[this.reportsIndex] = null;
        newSearchData[this.reportCategoryIndex] = null;
        let filteredReports = [];
        let validReportCategories = [];

        hotelReportList.forEach((report) => {
          if (report.scheduleType === selectedOption) {
            //filtering reports by schedule
            filteredReports.push(report.reportName);

            report.reportCategory.forEach((category) => {
              //filtering report category by schedule
              if (!validReportCategories.includes(category)) {
                validReportCategories.push(category);
              }
            });
          }
        });

        newSearchData[key] = {
          searchVal: selectedOption,
          searchIn: searchIn,
        };

        this.setState({
          searchData: newSearchData,
          reportData: filteredReports,
          validReportCategories: validReportCategories,
        });

        // }else if(valuesType === "Report"){

        //     let hotelReportList = this.state.hotelReportList;

        //     let validSubmissionSchedules = [];

        //     let reportSchedule = hotelReportList.filter( report => {
        //             return (report.reportName === selectedOption);
        //         }
        //     );
        //     if(reportSchedule.length != 0){
        //         validSubmissionSchedules = [reportSchedule[0].scheduleType];
        //     }

        //     newSearchData[key] = {
        //         "searchVal" : selectedOption,
        //         "searchIn" : searchIn
        //     };

        //     this.setState({
        //         searchData : newSearchData,
        //         validSubmissionSchedules : validSubmissionSchedules
        //     });
      } else {
        newSearchData[key] = {
          searchVal: selectedOption,
          searchIn: searchIn,
        };

        this.setState({ searchData: newSearchData });
      }
    }
  }

  checkNull(checkObj) {
    let keyList = Object.keys(checkObj);
    for (let x = 0; x < keyList.length; x++) {
      if (checkObj[keyList[x]] != null) {
        return false;
      }
    }
    return true;
  }

  searchReportData(isFromClear) {
    // alert(JSON.stringify(this.state.searchData));
    this.state.data = {};
    this.totalRecords = 0;
    this.allRecords = 0;
    this.page = 0;
    this.archivePage = 0;
    let searchData = this.state.searchData;
    // alert(JSON.stringify(this.state.reportData))
    // let hotel = (this.state.searchData["hotel"] == null) ? null : { "hotelName" : this.state.searchData["hotel"]["name"] , "hotelCode" : this.state.searchData["hotel"]["code"]};
    // let report = (this.state.searchData["report"] == null) ? null : this.state.searchData["report"]["label"];
    // let businessDate = this.state.searchData["businessDate"];
    // let uploadDate = this.state.searchData["uploadDate"];
    // let connector = this.state.searchData["connector"];
    let searchObj = {
      date: null,
      time: null,
      filterSearch: searchData,
      //     hotel: hotel,
      //     report: report,
      //     businessDate: businessDate,
      //     uploadDate: uploadDate,
      //     connector: connector
    };
    // alert(this.checkNull(searchObj.filterSearch))
    if (this.checkNull(searchObj.filterSearch)) {
      searchObj.date = this.state.sessionData["date"];
      searchObj.time = this.state.sessionData["time"];
    }

    if (isFromClear) {
      this.props.setSidebarSelected(true);
    } else {
      this.props.setSidebarSelected(false);
    }

    this.loadData(searchObj, false, null, false);
  }

  componentWillReceiveProps(newProps) {
    //to update tables by updating session data
    if (newProps.isOpen != this.state.isOpen) {
      this.setState({
        isOpen: newProps.isOpen,
      });
      return;
    }
    if (this.state.reduxLoadingCount < newProps.loadingStatus) {
      this.setState({
        reduxLoadingCount: newProps.loadingStatus,
        contentLoadingStatus: false,
      });
      return;
    }

    let sessionStorageData = JSON.parse(sessionStorage.getItem("sessionData"));
    if (sessionStorageData == null) {
      sessionStorageData = { date: "null", time: "null" };
    }

    if (sessionStorageData.sidebarClick) {
      this.setSidebarClick(sessionStorageData.sidebarClick);
    }

    this.state.sessionData = sessionStorageData;
    this.state.data = [];
    this.state.isEditable = false;
    this.state.isEditableLbl = editOptions.edit;
    this.state.editedRows = {};
    this.state.searchData = {
      hotel: null,
      report: null,
      uploadDate: null,
      businessDate: null,
      connector: null,
    };

    this.page = 0;
    this.archivePage = 0;

    this.lastSearch = {};
    this.disableNext = true;
    this.totalRecords = 0;

    this.loadData(
      {
        date: this.state.sessionData["date"],
        time: null,
        hotel: null,
        report: null,
        businessDate: null,
        uploadDate: null,
        connector: null,
      },
      false,
      null,
      false
    );
  }

  componentDidMount() {
    this.page = 0;
    this.archivePage = 0;
    this.lastSearch = {};
    let entityId = null;
    let projectId = null;

    //pms
    let match = this.props.match;
    if (match.params !== undefined && match.params.pms !== undefined) {
      sessionStorage.setItem("pms", match.params.pms);
    }
    if (match.params !== undefined && match.params.entityId !== undefined) {
      entityId = match.params.entityId;
    }
    if (match.params !== undefined && match.params.projectId !== undefined) {
      projectId = match.params.projectId;
    }

    //solutions
    let solutions = this.props.solutions;
    if (solutions == undefined || solutions.length === 0) {
      this.printError({
        display: true,
        err: true,
        errCode: "Error",
        errType: "pageErr",
        errMsg: "400 - No Solutions",
      });

      return;
    }

    //Tabs
    let result = this.changeHMG(entityId, projectId);
    if (!result) {
      return;
    }

    if (
      match.params !== undefined &&
      match.params.eventDateTime !== undefined
    ) {
      var datepara = "null";
      var timepara = "null";
      if (match.params.eventDateTime.indexOf("T") !== -1) {
        datepara = match.params.eventDateTime.substring(
          0,
          match.params.eventDateTime.indexOf("T")
        );
        var temptimepara = match.params.eventDateTime.substring(
          match.params.eventDateTime.indexOf("T") + 1
        );
        if (
          moment(datepara, "YYYY-MM-DD", true).isValid() === true &&
          moment(temptimepara, "HH:mm:ss", true).isValid() === true
        ) {
          let dte = moment.utc(datepara + " " + temptimepara);
          let localSession = moment(dte).local();
          timepara = moment(localSession).format("hh:mm:ss A");
          datepara = moment(localSession).format("MM-DD-YYYY");

          //let utcDate = new Date(datepara+" "+temptimepara+" UTC");
          //timepara = moment(utcDate).format('hh:mm:ss A');
          //datepara =  moment(utcDate).format('MM-DD-YYYY');
          let sessionStorageData = {
            date: datepara,
            time: timepara,
          };
          this.state.sessionData = sessionStorageData;
          sessionStorage.setItem(
            "sessionData",
            JSON.stringify(sessionStorageData)
          );
        } else {
          // error message 400
          this.printError({
            display: true,
            err: true,
            errCode: "Error",
            errType: "pageErr",
            errMsg: "400 - Invalid Request",
          });

          return;
        }
      } else {
        //no time or something else
        datepara = match.params.eventDateTime;
        if (moment(datepara, "YYYY-MM-DD", true).isValid() === true) {
          datepara = moment(datepara, "YYYY-MM-DD").format("MM-DD-YYYY");
          let sessionStorageData = {
            date: datepara,
            time: timepara,
          };
          this.state.sessionData = sessionStorageData;
          sessionStorage.setItem(
            "sessionData",
            JSON.stringify(sessionStorageData)
          );
        }
      }
    }

    if (this.state.sessionData["date"] !== null) {
      this.loadData(
        {
          // date: null,
          // time: null,
          date: this.state.sessionData["date"],
          time: this.state.sessionData["time"],
          hotel: null,
          report: null,
          businessDate: null,
          uploadDate: null,
          connector: null,
        },
        false,
        null,
        false
      );
    }
  }

  page = 0;
  archivePage = 0;
  size = 10;
  lastSearch = {};
  disableNext = false;
  //disablePrev = true;
  totalRecords = 0;
  allRecords = 0;
  project = "";
  projectDetails = [];
  defaultTab = "";
  reportsIndex = "";
  businessDateIndex = "";
  submissionScheduleIndex = "";
  reportsIndexValues = [];
  reportCategoryIndex = "";
  reportCategoryIndexValues = [];

  changeHMG(entityId, projectId) {
    entityId = entityId ? parseInt(entityId) : entityId;
    projectId = projectId ? parseInt(projectId) : projectId;
    let tabList = [];
    let projectList = [];
    let preSelected = null;
    let pnaSelected = null;
    let hmgList = [];
    let currentHMG = this.state.currentHMG;
    // console.log("CHECK", this.props.solutions);
    for (const hmgObj of this.props.solutions) {
      hmgList.push({ hmgName: hmgObj.hmg_name, entityId: hmgObj.entityId });

      let validProject = hmgObj["projectList"].filter((proj) => {
        return proj.project_id === projectId;
      })[0];

      hmgObj["projectList"].forEach((solution) => {
        if (entityId === null) {
          entityId = hmgObj.entityId;
          currentHMG = hmgObj.hmg_name;
        } else if (currentHMG === "" && projectId !== null && validProject) {
          currentHMG = hmgObj.hmg_name;
        }

        if (entityId == hmgObj.entityId && currentHMG === hmgObj.hmg_name) {
          if (!projectList.includes(solution.solution)) {
            projectList.push(solution.solution);
          }

          if (projectId != null && projectId == solution.project_id) {
            preSelected = solution.solution;
          }
        }
      });
    }

    if (projectList.length === 0) {
      this.printError({
        display: true,
        err: true,
        errCode: "Error",
        errType: "pageErr",
        errMsg: "No solutions",
      });
      return false;
    }

    for (let x = 0; x < projectList.length; x++) {
      let project = projectList[x];
      //forcing PNA
      let tab = <TabPane tab={project} key={project}></TabPane>;
      if (project.toUpperCase() === "PNA") {
        pnaSelected = x;
        tabList = [tab].concat(tabList);
      } else {
        tabList.push(tab);
      }
    }

    // alert(preSelected)
    if (preSelected != null) {
      this.project = preSelected;
      this.defaultTab = this.project;
    } else {
      if (pnaSelected != null) {
        this.project = projectList[pnaSelected];
      } else {
        this.project = projectList[0];
      }
    }
    // this.project = (preSelected == null)?projectList[0]["solution"]:preSelected;
    this.state.tabList = tabList;
    this.state.hmgList = hmgList;
    this.state.entityId = entityId;
    this.state.currentHMG = currentHMG;
    this.state.changeHMGEvent = !this.state.changeHMGEvent;
    this.selectTab(this.project, null);
    return true;
  }

  selectTab(project, event) {
    this.defaultTab = project;
    this.project = project;
    this.page = 0;
    this.archivePage = 0;
    this.lastSearch = {};
    this.fromSearch = false;
    this.endofPage = false;
    this.totalRecords = 0;
    this.allRecords = 0;

    let newState = {
      data: {},
      isEditable: false,
      isEditableLbl: editOptions.edit,
      editedRows: {},
      searchData: {},
      reportData: [],
      changeHMGEvent: !this.state.changeHMGEvent,
    };

    //get indexes

    let projectDetails = [];

    for (const hmgObj of this.props.solutions) {
      if (
        hmgObj.entityId === this.state.entityId &&
        hmgObj.hmg_name === this.state.currentHMG
      ) {
        hmgObj["projectList"].forEach((solution) => {
          if (project === solution.solution) {
            projectDetails.push({
              entityId: hmgObj.entityId,
              projectId: solution.project_id,
            });
          }
        });
      }
    }
    this.projectDetails = projectDetails;
    let pms = sessionStorage.getItem("pms");
    let searchData = {
      userName: this.props.user["https://myapp.com/UserName"],
      projDetails: projectDetails,
      pms: pms === "null" ? null : pms,
    };
    this.setState({ contentLoadingStatus: true });
    axiosInstanceQMS
      .post("/api/callExternal/getAppConfig", searchData)
      .then((response) => {
        if (response["data"]["error"]) {
          console.error("ERROR :", response["data"]["errorMessage"]);

          let errorMessage =
            response["data"]["display"] != undefined &&
            response["data"]["display"]
              ? response["data"]["errorMessage"]
              : "Error occured";
          this.printError({
            display: true,
            err: true,
            errCode: "500",
            errType: "",
            errMsg: errorMessage,
          });
          return;
        } else {
          // alert(JSON.stringify(response["data"]["data"]));
          newState.tableIndexes =
            response["data"]["data"]["sessionTableIndexes"];
          newState.searchIndexes =
            response["data"]["data"]["searchableIndexes"];
          newState.allowedConnectors = response["data"]["data"]["connectors"];
          newState.indexSortOrder = response["data"]["data"]["sort"];
          newState.uniqueIndexes = response["data"]["data"]["uniqueIndexes"];

          for (const index of newState.tableIndexes) {
            if (index.valuesType === commonValuesTypes.DATE) {
              this.businessDateIndex = index.name;
            } else if (index.valuesType === commonValuesTypes.REPORT) {
              this.reportsIndex = index.name;
              this.reportsIndexValues = index.values;
              newState.reportData = index.values;
            } else if (
              index.valuesType === commonValuesTypes.SUBMISSION_SCHEDULE
            ) {
              this.submissionScheduleIndex = index.name;
            }
          }

          for (const index of newState.searchIndexes) {
            if (index.valuesType === commonValuesTypes.REPORT_CATEGORY) {
              this.reportCategoryIndex = index.name;
              this.reportCategoryIndexValues = index.values;
              newState.validReportCategories = index.values;
              break;
            }
          }

          //search data
          sessionStorage.removeItem("sessionData");
          this.setState(newState, () => {
            this.props.setSidebarSolution(
              {
                solutionName: project,
                projectDetails: projectDetails,
              },
              newState.allowedConnectors,
              newState.uniqueIndexes
            );
            if (!this.props.isOpen) {
              this.props.setToggleSidebar();
            }
          });
        }
      })
      .catch((error) => {
        console.error("ERROR :", error);
        this.printError({
          display: true,
          err: true,
          errCode: "400",
          errType: "",
          errMsg: "Error occured : " + error.message,
        });
        return;
      });
  }

  refresh() {
    this.setState({ contentLoadingStatus: true }, () => {
      this.loadData(
        {
          date: null,
          time: null,
          hotel: null,
          report: null,
          businessDate: null,
          uploadDate: null,
        },
        false,
        null,
        true
      );
    });
  }

  async loadData(params, fromPage, prevNext, refresh) {
    if (this.state.allowedConnectors.length === 0) {
      return;
    }

    if (!refresh && !fromPage) {
      if (prevNext === null) {
        this.page = 0;
        this.archivePage = 0;
      }

      this.lastSearch = {};
      //this.disablePrev = true;
      this.disableNext = false;

      if (params["date"] != null) {
        if (
          params["time"] !== null &&
          params["time"] !== "" &&
          params["time"] !== "null"
        ) {
          let fmtTime = moment(
            params["date"] + " " + params["time"],
            "MM-DD-YYYY hh:mm:ss A"
          )
            .utc()
            .format("HH:mm:ss");
          let fmtDate = moment(
            params["date"] + " " + params["time"],
            "MM-DD-YYYY hh:mm:ss A"
          )
            .utc()
            .format("YYYY-MM-DD");

          params["time"] = fmtTime;
          params["date"] = fmtDate;
        } else {
          params["date"] = moment(params["date"], "MM-DD-YYYY").format(
            "YYYY-MM-DD"
          );
        }
      }
      // }
      let email = this.props.user.email;
      // let userId = this.props.user.sub.replace("auth0|", "").toString();
      let pms = sessionStorage.getItem("pms");
      this.setState({ contentLoadingStatus: true });
      params["email"] = email;
      params["user"] = this.props.user.name;
      params["pms"] = pms === "null" ? null : pms;
      // if (params["uploadDate"] !== null && params["uploadDate"] !== "null" && params["uploadDate"] !== "" && !fromPage) {
      //     params["uploadDate"] = moment(params["uploadDate"], 'MM-DD-YYYY').format('YYYY-MM-DD');
      // }
      params["offset"] = new Date().getTimezoneOffset();
      this.lastSearch = JSON.parse(JSON.stringify(params));
    } else if (fromPage) {
      if (prevNext === "p") {
        if (this.page > 0) {
          //this.disablePrev = false;
          this.disableNext = false;
          if (this.archivePage > 0) {
            this.archivePage = this.archivePage - 1;
          } else {
            this.page = this.page - 1;
          }
        } else {
          //this.disablePrev = true;
          this.setState({ contentLoadingStatus: false });
          return;
        }
      }
      if (prevNext === "n") {
        //this.disablePrev = false;
        // if(this.archivePage > 0){
        //     this.archivePage = this.archivePage + 1;
        // }else{
        //     this.page = this.page+1;
        // }
      }
    } else if (refresh) {
      this.page = 0;
      this.archivePage = 0;
      params = JSON.parse(JSON.stringify(this.lastSearch));
    }

    params["archivePage"] = this.archivePage;
    params["page"] = this.page;
    params["size"] = this.size;
    params["project"] = this.project;
    params["from"] = "GM";
    params["uniqueIndexes"] = this.state.uniqueIndexes;
    params["accessType"] = this.props.accessType;
    params["projectDetails"] = this.projectDetails;
    params["businessDateIndex"] = this.businessDateIndex;
    params["reportsIndex"] = this.reportsIndex;
    params["submissionScheduleIndex"] = this.submissionScheduleIndex;
    let userId = this.props.user["https://myapp.com/UserName"];
    params["userId"] = userId;
    params["allowedConnectors"] = this.state.allowedConnectors;
    axiosInstanceQMS
      .post("/api/fileTrace/getUserFileTraceSessionData", params)
      .then((response) => {
        if (response["data"]["error"]) {
          console.error("ERROR :", response["data"]["errorMessage"]);
          // if (prevNext === "n") {
          //     if(this.archivePage > 0){
          //         this.archivePage = this.archivePage - 1;
          //     }else if(this.page > 0){
          //         this.page = this.page - 1;
          //     }
          // }

          let errorMessage =
            response["data"]["display"] != undefined &&
            response["data"]["display"]
              ? response["data"]["errorMessage"]
              : "Error occured";
          this.printError({
            display: true,
            err: true,
            errCode: "500",
            errType: "",
            errMsg: errorMessage,
          });
          return;
        }
        this.allRecords = response.data.total;
        if (fromPage && Object.keys(response.data.data).length === 0) {
          //alert("No Data rolling back page");
          // if (prevNext === "n") {
          //     if(this.archivePage > 0){
          //         this.archivePage = this.archivePage - 1;
          //     }else if(this.page > 0){
          //         this.page = this.page - 1;
          //     }
          // }
          this.disableNext = true;
          this.setState({ contentLoadingStatus: false });
        } else {
          if (response["data"]["archiveUsed"]) {
            this.archivePage = this.archivePage + 1;
          } else {
            this.page = this.page + 1;
          }

          let newOriginalData = JSON.parse(
            JSON.stringify(this.state.originalData)
          );
          let responseData = JSON.parse(JSON.stringify(response.data.data));

          let count = 0;
          let keys = Object.keys(responseData);
          keys.forEach((key) => {
            count += responseData[key].length;
          });

          if (count < this.size) {
            this.disableNext = true;
          } else {
            this.disableNext = false;
          }

          if (fromPage) {
            if (newOriginalData[" "] === undefined) {
              newOriginalData[" "] = [];
            }
            newOriginalData[" "] = newOriginalData[" "].concat(
              responseData[" "]
            );
          } else {
            newOriginalData = JSON.parse(JSON.stringify(responseData));
          }

          let data = JSON.parse(JSON.stringify(newOriginalData));

          this.totalRecords = 0;
          Object.keys(newOriginalData).forEach((originalKey) => {
            this.totalRecords = newOriginalData[originalKey].length;
          });
          if (this.totalRecords == this.allRecords) {
            this.disableNext = true;
          }
          this.setState({
            originalData: newOriginalData,
            contentLoadingStatus: false,
          });
          this.resetData(data);
        }
      })
      .catch((error) => {
        console.error("ERROR :", error);
        // if (prevNext === "n") {
        //     if(this.archivePage > 0){
        //         this.archivePage = this.archivePage - 1;
        //     }else if(this.page > 0){
        //         this.page = this.page - 1;
        //     }
        // }

        this.printError({
          display: true,
          err: true,
          errCode: "400",
          errType: "",
          errMsg: "Error occured : " + error.message,
        });
      });
  }

  updateSessionData(sessionTime, newData, newEditedRows) {
    const sessionTableData = this.state.data;
    const sessionEditedRows = this.state.editedRows;

    sessionTableData[sessionTime] = newData;
    sessionEditedRows[sessionTime] = newEditedRows;

    this.setState({
      data: sessionTableData,
      editedRows: sessionEditedRows,
    });
  }

  updateDropdownData(sessionTime, newEditedDropdown, newEditedRows) {
    const editedDropdown = this.state.editedDropdown;
    const sessionEditedRows = this.state.editedRows;

    for (let x = 0; x < editedDropdown.length; x++) {
      if (editedDropdown[x]["ddId"] == newEditedDropdown["ddId"]) {
        newEditedDropdown["ddCid"] = editedDropdown[x]["ddCid"];
        editedDropdown[x] = newEditedDropdown;
        break;
      }
    }
    sessionEditedRows[sessionTime] = newEditedRows;

    this.setState({
      editedDropdown: editedDropdown,
      editedRows: sessionEditedRows,
    });
  }

  toggleEdit() {
    //toggle edit button
    this.setState({
      isEditable: !this.state.isEditable,
      isEditableLbl: this.state.isEditable
        ? editOptions.edit
        : editOptions.cancel,
      editedRows: this.state.isEditable ? [] : this.state.editedRows,
    });
    //if cancel reset original data
    if (this.state.isEditable) {
      this.resetData(cloneDeep(this.state.originalData));
    }
  }

  resetData(newData) {
    //set at init or at reset (Cancel btn)
    //dropdown components of chain ids
    let newEditedDropdown = [];
    let newEditedRows = {};
    let dataKeyList = Object.keys(newData);
    let hide = true;
    for (let x = 0; x < dataKeyList.length; x++) {
      //!!!! This can be optimized later.. maybe
      let newDataList = newData[dataKeyList[x]];
      newEditedRows[dataKeyList[x]] = [];
      for (let z = 0; z < newDataList.length; z++) {
        //alert(newDataList[z]["eventTime"]+" "+(newDataList[z]["eventTime"].indexOf("T") > -1));
        if (newDataList[z]["eventTime"].indexOf("T") > -1) {
          let dte = moment.utc(newDataList[z]["eventTime"]);
          let localSession = moment(dte).local();
          let timepara = moment(localSession).format("hh:mm:ss A");
          let datepara = moment(localSession).format("MM-DD-YYYY");
          let fmtSessionTime = datepara + " - " + timepara;
          newDataList[z]["eventTime"] = fmtSessionTime;
        }
        for (let y = 0; y < newDataList[z]["reports"].length; y++) {
          //add chainId reports in new data
          newDataList[z]["reports"][y]["chainId"] = newDataList[z]["chainId"];
          //add to custom edit dropdown array
          newEditedDropdown.push({
            ddCid: newDataList[z]["reports"][y]["chainId"],
            ddVal: newDataList[z]["reports"][y]["typeId"],
            ddId: newDataList[z]["reports"][y]["id"],
          });
        }
        //show alert if smart scan is sync
        if (newDataList[z]["smartScanning"] === "Sync") {
          hide = false;
        }
      }
    }
    //reset state data and editable dropdowns
    this.setState({
      data: newData,
      editedDropdown: newEditedDropdown,
      editedRows: newEditedRows,
      hideAlert: hide,
    });
  }

  saveData() {
    this.setState({ contentLoadingStatus: true }, () => {
      //array Containing update data
      let toBeUpdated = [];
      //ketlist for session ids
      let dataKeyList = Object.keys(this.state.editedRows);
      //alert(JSON.stringify(this.state.editedRows));
      let editedDropDowns = this.state.editedDropdown;
      //loop sessions to be updated
      for (let x = 0; x < dataKeyList.length; x++) {
        //array containing rowids for session
        let tableData = this.state.editedRows[dataKeyList[x]];
        console.log(
          "tableData at save",
          tableData,
          "edited datakeys",
          dataKeyList,
          "editedDropDowns",
          editedDropDowns
        );
        let newData = cloneDeep(this.state.data[dataKeyList[x]]);
        newData.forEach((tableRow) => {
          if (
            tableData.includes(tableRow["chainId"]) &&
            !toBeUpdated.includes(tableRow["chainId"])
          ) {
            //add data prepared to be updated
            toBeUpdated.push(tableRow);
          }
        });
      }
      //alert(JSON.stringify(toBeUpdated));
      axiosInstanceQMS
        .post("/api/fileTrace/saveFiletraceEditedData", {
          updateData: toBeUpdated,
        })
        .then((response) => {
          //alert(JSON.stringify(response["data"]));
          if (response["data"]["error"]) {
            let errorMessage =
              response["data"]["display"] != undefined &&
              response["data"]["display"]
                ? response["data"]["errorMessage"]
                : "Error occured";
            this.printError({
              display: true,
              err: true,
              errCode: "500",
              errType: "",
              errMsg: errorMessage,
            });
            return;
          } else {
            // let size = response["data"]["arr"].length;
            this.toggleEdit(false);
            //setTimeout(this.searchReportData, (size * 2200));
            this.refresh();
          }
        })
        .catch((error) => {
          console.error("ERROR :", error);
          this.printError({
            display: true,
            err: true,
            errCode: "400",
            errType: "",
            errMsg: "Error occured : " + error.message,
          });
        });
    });
  }

  //mimic java Collections -> Set data structure on arrays
  pushSet(val, arr, parse, prop) {
    for (let x = 0; x < arr.length; x++) {
      if (prop != null && arr[x][prop] == val) {
        return arr;
      } else if (prop == null && arr[x] == val) {
        return arr;
      }
    }
    val = parse ? parseInt(val) : val;
    arr.push(val);
    return arr;
  }

  changePage(prevNext) {
    this.setState({ contentLoadingStatus: true }, () => {
      this.loadData(this.lastSearch, true, prevNext, false);
    });
  }

  render() {
    // alert('render');
    let dataKeyList = Object.keys(this.state.data);
    let sessionTableList = [];
    this.state.tabId = [];
    if (
      this.errorObject.err === false ||
      (this.errorObject.err && this.errorObject.errType !== "pageErr")
    ) {
      if (dataKeyList.length === 0) {
        sessionTableList.push(
          <div key="noTableDataEmptyElement" className="noDataTableSection">
            <Row gutter={[40, 32]} type="flex" justify="center">
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No File Found"
                />
              </Col>
            </Row>
          </div>
        );
      } else {
        for (let x = 0; x < dataKeyList.length; x++) {
          let tabId = "userSessionTab_" + x;
          //alert(dataKeyList[x])
          sessionTableList.push(
            <FileTraceTableSection
              key={tabId}
              tabId={tabId}
              tableData={this.state.data[dataKeyList[x]]}
              updateSessionData={this.updateSessionData}
              updateDropdownData={this.updateDropdownData}
              sessionTime={dataKeyList[x]}
              isEditable={this.state.isEditable}
              editedRows={this.state.editedRows[dataKeyList[x]]}
              editedDropdown={this.state.editedDropdown}
              mappedReports={this.state.mappedReports}
              accessType={this.props.accessType}
              openModal={this.openModal}
              permitExtraDetails={this.props.permitExtraDetails}
              defaultActive={[dataKeyList[0]]}
              changePage={this.changePage}
              disableNext={this.disableNext}
              gmTotal={this.totalRecords}
              allRecords={this.allRecords}
              solution={this.project}
              tableIndexes={this.state.tableIndexes}
              indexSortOrder={this.state.indexSortOrder}
              submissionScheduleIndex={this.submissionScheduleIndex}
            />
          );
          let tabIds = this.state.tabId;
          this.state.tabId = this.pushSet(tabId, tabIds, false, null);
        }
      }
    }

    return (
      // fileTraceView
      this.errorObject.err === true &&
        this.errorObject.errType === "pageErr" ? (
        <QMSErrorHandle errordetails={this.errorObject} />
      ) : (
        <div
          className={
            "filetrace " +
            (this.props.isOpen ? "sidebarExpand" : "sidebarCollapse")
          }
        >
          <QMSErrorHandle errordetails={this.errorObject} />
          <Spin tip="Loading..." spinning={this.state.contentLoadingStatus}>
            <div hidden={this.state.hideAlert ? "hidden" : ""}>
              <Row gutter={[0, 32]} type="flex" justify="space-around">
                <Col span={24}>
                  <FileTraceAlertSection />
                </Col>
              </Row>
            </div>
            {this.state.hideAlert ? <br /> : ""}
            <Row gutter={[40, 0]} type="flex" justify="space-around">
              <Col span={20}>
                <Row hidden={this.state.hmgList.length === 1}>
                  <Col span={5}>Hotel Management Group</Col>
                  <Col span={9}>
                    <Select
                      style={{ width: "100%" }}
                      value={this.state.currentHMG}
                      onChange={(value) => {
                        let filteredHMG = this.state.hmgList.filter((obj) => {
                          return obj.hmgName === value;
                        });

                        let currentEntityId = filteredHMG[0]
                          ? filteredHMG[0].entityId
                          : 0;
                        this.setState(
                          { entityId: currentEntityId, currentHMG: value },
                          () => {
                            this.changeHMG(currentEntityId, null);
                          }
                        );
                      }}
                    >
                      {this.state.hmgList.map((hmg) => {
                        return (
                          <Option value={hmg.hmgName}>{hmg.hmgName}</Option>
                        );
                      })}
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col span={2}></Col>
            </Row>
            <br />
            <Row gutter={[40, 0]} type="flex" justify="space-around">
              <Col span={23}>
                <Tabs
                  activeKey={this.defaultTab}
                  type="card"
                  id="projectTab"
                  size="default"
                  onTabClick={this.selectTab}
                  tabPosition="top"
                  tabBarExtraContent={
                    <span>
                      Refresh Data
                      <Tooltip title="Refresh Data">
                        <Button
                          type="primary"
                          onClick={() => this.refresh()}
                          icon={
                            <SyncOutlined
                              style={{ verticalAlign: "0.125em" }}
                            />
                          }
                          style={{ marginLeft: "0.5rem" }}
                        ></Button>
                      </Tooltip>
                    </span>
                  }
                >
                  {this.state.tabList}
                </Tabs>
              </Col>
            </Row>
            <Row
              gutter={[40, 0]}
              type="flex"
              justify="space-around"
              className="filetraceFilterSection"
            >
              <Col span={23}>
                <FileTraceFilterSection
                  updateSearchData={this.updateSearchData}
                  searchReportData={this.searchReportData}
                  reportData={this.state.reportData}
                  reportVal={this.state.searchData.report}
                  hotelVal={this.state.searchData.hotel}
                  searchData={this.state.searchData}
                  connector={this.state.searchData.connector}
                  user={this.props.user}
                  searchIndexes={this.state.searchIndexes}
                  allowedConnectors={this.state.allowedConnectors}
                  indexSortOrder={this.state.indexSortOrder}
                  // searchReportData={this.searchReportData}
                  clearSearch={this.clearSearch}
                  projectDetails={this.projectDetails}
                  hotelSelected={this.state.hotelSelected}
                  validSubmissionSchedules={this.state.validSubmissionSchedules}
                  validReportCategories={this.state.validReportCategories}
                  resetHotel={this.resetHotel}
                  resetBDate={this.resetBDate}
                  changeHMGEvent={this.state.changeHMGEvent}
                  sidebarClick={this.sidebarClick}
                  setSidebarClick={this.setSidebarClick}
                />
              </Col>
            </Row>
            <Row
              gutter={[40, 32]}
              type="flex"
              justify="space-around"
              className="filetraceSessionTableSection"
            >
              <Col span={23}>{sessionTableList}</Col>

              <Modal
                title={this.state.modalProps.title}
                visible={this.state.modalVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                okButtonProps={{ disabled: true }}
                cancelButtonProps={{ disabled: true }}
                footer={null}
                width={1000}
              >
                <div class="processTimelineBody">
                  <Row gutter={[20, 20]} type="flex" justify="center">
                    <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                      <div class="processTimeLineData">
                        <Steps
                          current={this.state.modalProps.current}
                          onChange={this.stepChange}
                          direction="vertical"
                        >
                          {this.state.modalProps.content}
                        </Steps>
                      </div>
                    </Col>
                    {this.props.permitExtraDetails.AdditionalDataView ? (
                      <Col xs={24} sm={24} md={15} lg={15} xl={15}>
                        <div class="additionalData">
                          <div class="additionalDataLable">
                            Additional Data :{" "}
                            {this.state.modalProps.currentStepName}
                          </div>
                          <div class="additionalDataSection">
                            {this.state.modalProps.additionalDataStr}
                          </div>
                          <div class="additionalDataTimestamp">
                            {this.state.modalProps.additionalDataTS}
                          </div>
                        </div>
                      </Col>
                    ) : (
                      <div></div>
                    )}
                  </Row>
                </div>
              </Modal>
            </Row>
          </Spin>
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  let filetraceReducer = state.filetraceReducer;
  // console.log(filetraceReducer)
  return {
    loadingStatus: filetraceReducer.loadingStatus,
    isOpen: state.navbarReducer.isOpen,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setSidebarSolution: setSidebarSolution,
      setToggleSidebar: setToggleSidebar,
      setSidebarSelected: setSidebarSelected,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(FileTraceGM);
